import { APP_PERMISSIONS } from '@/shared/constants/app-permissions';
import { pageAuthorities } from '@/shared/auth/has-any-authority';
/** Sidebar menu — single source of truth for navigation labels, paths, and route authorities. */
export const APP_MENU_MODEL = [
    {
        label: 'Case Management',
        items: [
            {
                label: 'Dashboard',
                icon: 'pi pi-fw pi-home',
                to: '/',
                authorities: pageAuthorities(APP_PERMISSIONS.CASEMANAGEMENT_DASHBOARD),
            },
            {
                label: 'Agent Panel',
                icon: 'pi pi-fw pi-phone',
                to: '/crm/agent-panel',
                authorities: pageAuthorities(APP_PERMISSIONS.CASEMANAGEMENT_AGENTPANEL),
            },
            {
                label: 'Cases Panel',
                icon: 'pi pi-fw pi-inbox',
                to: '/crm/cases-panel',
                authorities: pageAuthorities(APP_PERMISSIONS.CASEMANAGEMENT_CASESPANEL, APP_PERMISSIONS.CASES_READ),
            },
            {
                label: 'Case Report',
                icon: 'pi pi-fw pi-list',
                to: '/crm/case-report',
                authorities: pageAuthorities(APP_PERMISSIONS.CASEMANAGEMENT_CASEREPORT, APP_PERMISSIONS.CASE_REPORT_READ, APP_PERMISSIONS.CASE_REPORT_ADMIN),
            },
            {
                label: 'Case Assignment',
                icon: 'pi pi-fw pi-user-plus',
                to: '/crm/case-assignment',
                authorities: pageAuthorities(APP_PERMISSIONS.CASEMANAGEMENT_CASEASSIGNMENT),
            },
            {
                label: 'Case Transfer',
                icon: 'pi pi-fw pi-arrow-right-arrow-left',
                to: '/crm/case-transfer',
                authorities: pageAuthorities(APP_PERMISSIONS.CASEMANAGEMENT_CASETRANSFER),
            },
            {
                label: 'Follow Up Cases',
                icon: 'pi pi-fw pi-calendar',
                to: '/crm/follow-up-cases',
                authorities: pageAuthorities(APP_PERMISSIONS.CASEMANAGEMENT_FOLLOWUPCASES, APP_PERMISSIONS.CASE_READ),
            },
            {
                label: 'Customer Helper',
                icon: 'pi pi-fw pi-user-edit',
                to: '/crm/customer-helper',
                authorities: pageAuthorities(APP_PERMISSIONS.UNLOCK_USER),
            },
            {
                label: 'Airplane Tickets',
                icon: 'pi pi-fw pi-calendar-plus',
                to: '/crm/airplane-tickets',
                authorities: pageAuthorities(APP_PERMISSIONS.FINANCIAL_AIRPLANETICKET, APP_PERMISSIONS.AIRPLANE_TICKET_READ),
            },
            {
                label: 'Case Categories',
                icon: 'pi pi-fw pi-tags',
                to: '/crm/case-categories',
                authorities: pageAuthorities(APP_PERMISSIONS.CASEMANAGEMENT_CASECATEGORIES, APP_PERMISSIONS.CASE_CATEGORY_READ),
            },
            {
                label: 'Team Chat',
                icon: 'pi pi-fw pi-comments',
                to: '/crm/chat',
                authorities: pageAuthorities(APP_PERMISSIONS.CHATROOM_READ, APP_PERMISSIONS.CHATMESSAGE_READ),
            },
        ],
    },
    {
        label: 'Location',
        items: [
            {
                label: 'Provinces',
                icon: 'pi pi-fw pi-map',
                to: '/crm/provinces',
                authorities: pageAuthorities(APP_PERMISSIONS.CASEMANAGEMENT_PROVINCE, APP_PERMISSIONS.PROVINCE_READ),
            },
            {
                label: 'Districts',
                icon: 'pi pi-fw pi-map-marker',
                to: '/crm/districts',
                authorities: pageAuthorities(APP_PERMISSIONS.CASEMANAGEMENT_PROVINCE, APP_PERMISSIONS.PROVINCE_READ),
            },
        ],
    },
    {
        label: 'Call Center',
        items: [
            {
                label: 'Queue Statistics Dashboard',
                icon: 'pi pi-fw pi-chart-line',
                to: '/qstat',
                authorities: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_DASHBOARD, APP_PERMISSIONS.CALL_CENTER_READ, APP_PERMISSIONS.DASHBOARD_INCOMINGCALLS, APP_PERMISSIONS.DASHBOARD_OUTGOINGCALLS, APP_PERMISSIONS.DASHBOARD_AGENTS, APP_PERMISSIONS.DASHBOARD_CALLQUEUES),
            },
            {
                label: 'KPI Dashboard',
                icon: 'pi pi-fw pi-chart-bar',
                to: '/qstat/kpi-dashboard',
                authorities: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_KPIDASHBOARD, APP_PERMISSIONS.DASHBOARD_KPI),
            },
            {
                label: 'Incoming Calls Report',
                icon: 'pi pi-fw pi-phone',
                to: '/qstat/incoming',
                authorities: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_INCOMINGCALLS, APP_PERMISSIONS.INCOMING_READ, APP_PERMISSIONS.INCOMINGCALLS_ADMIN),
            },
            {
                label: 'Outgoing Calls Report',
                icon: 'pi pi-fw pi-phone',
                to: '/qstat/outgoing',
                authorities: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_OUTGOINGCALLS, APP_PERMISSIONS.OUTGOING_READ, APP_PERMISSIONS.OUTGOINGCALLS_ADMIN),
            },
            {
                label: 'Queue Status Report',
                icon: 'pi pi-fw pi-chart-bar',
                to: '/qstat/queue-status',
                authorities: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_QUEUE_STATUS, APP_PERMISSIONS.QUEUELOG_READ),
            },
            {
                label: 'Real Time Activities',
                icon: 'pi pi-fw pi-bolt',
                to: '/qstat/realtime',
                authorities: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_REALTIME, APP_PERMISSIONS.REALTIME_ACTIVECALLS, APP_PERMISSIONS.REALTIME_QUEUEINFORMATION),
            },
            {
                label: 'Session Report',
                icon: 'pi pi-fw pi-clock',
                to: '/settings/users/session-report',
                authorities: pageAuthorities(APP_PERMISSIONS.SETTINGS_SESSIONREPORT, APP_PERMISSIONS.SESSIONREPORT_ADMIN),
            },
            {
                label: 'Break Report',
                icon: 'pi pi-fw pi-pause',
                to: '/settings/users/break-report',
                authorities: pageAuthorities(APP_PERMISSIONS.BREAK_REPORT_READ),
            },
        ],
    },
    {
        label: 'Campaigns',
        items: [
            {
                label: 'Campaign Dashboard',
                icon: 'pi pi-fw pi-chart-bar',
                to: '/campaigns/dashboard',
                authorities: pageAuthorities(APP_PERMISSIONS.CAMPAIGNS_DASHBOARD),
            },
            {
                label: 'Campaign List',
                icon: 'pi pi-fw pi-list',
                to: '/campaigns/campaign-list',
                authorities: pageAuthorities(APP_PERMISSIONS.CAMPAIGNS_LIST, APP_PERMISSIONS.CAMPAIGN_READ),
            },
        ],
    },
    {
        label: 'Settings',
        items: [
            {
                label: 'Users',
                icon: 'pi pi-fw pi-users',
                to: '/settings/users',
                authorities: pageAuthorities(APP_PERMISSIONS.SETTINGS_USERS, APP_PERMISSIONS.USER_READ),
            },
            {
                label: 'Agent Productivity',
                icon: 'pi pi-fw pi-chart-line',
                to: '/settings/users/agent-productivity-report',
                authorities: pageAuthorities(APP_PERMISSIONS.SETTINGS_AGENTPRODUCTIVITYREPORT, APP_PERMISSIONS.AGENTPRODUCTIVITYREPORT_ADMIN),
            },
            {
                label: 'Roles',
                icon: 'pi pi-fw pi-shield',
                to: '/settings/roles',
                authorities: pageAuthorities(APP_PERMISSIONS.SETTINGS_ROLES, APP_PERMISSIONS.ROLE_READ),
            },
            {
                label: 'Permissions',
                icon: 'pi pi-fw pi-key',
                to: '/settings/permissions',
                authorities: pageAuthorities(APP_PERMISSIONS.SETTINGS_PERMISSIONS, APP_PERMISSIONS.PERMISSION_READ),
            },
            {
                label: 'Branches',
                icon: 'pi pi-fw pi-building',
                to: '/crm/branches',
                authorities: pageAuthorities(APP_PERMISSIONS.CASEMANAGEMENT_BRANCHES, APP_PERMISSIONS.BRANCH_READ),
            },
            {
                label: 'Departments',
                icon: 'pi pi-fw pi-sitemap',
                to: '/settings/departments',
                authorities: pageAuthorities(APP_PERMISSIONS.SETTINGS_DEPARTMENTS, APP_PERMISSIONS.DEPARTMENT_READ),
            },
            {
                label: 'Audit Log',
                icon: 'pi pi-fw pi-history',
                to: '/settings/audit-log',
                authorities: pageAuthorities(APP_PERMISSIONS.SETTINGS_AUDITLOG, APP_PERMISSIONS.AUDIT_READ),
            },
            {
                label: 'Database Sync',
                icon: 'pi pi-fw pi-database',
                to: '/settings/database-sync',
                authorities: pageAuthorities(APP_PERMISSIONS.ADMIN),
            },
        ],
    },
];
